import React from 'react';

import { useTimer } from 'client/hooks/timer';

interface Props {
  date: string;
  handleCountdownEnded?: (i: boolean) => void;
}

const Timer: React.FC<Props> = (props) => {
  const { date, handleCountdownEnded } = props;
  const { currentTime, stopTimer, isCountdownEnded } = useTimer({ date });

  React.useEffect(() => {
    return () => stopTimer();
  }, []);

  React.useEffect(() => {
    if (isCountdownEnded && handleCountdownEnded) {
      handleCountdownEnded(true);
    }
  }, [isCountdownEnded]);

  return <>{currentTime}</>;
};

export default Timer;
